
import $ from 'jquery';
import { keyCodes } from '../../../../../@infinite/scripts/core/INF-keyCodes';

export default function() {
  $(document).on('click keyup', '[data-video-src]', (e) => {
    if (e.keyCode) {
      if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
    }

    const videoSrc = $(e.currentTarget).data('videoSrc');
    $('[data-modal-video-iframe]').attr('src', videoSrc).trigger('load');
  });

  // should fire on modalDidClose - have requested event in Infinite. Currenty fires on breakpoint change 
  $(document).on('menusWillClose', () => {
    $('[data-modal-video-iframe]').attr('src', '').trigger('load');
  });

  $(document).on('click keyup', '[data-rte-video]', (e) => {
    if (e.keyCode) {
      if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
    }

    const $videoContainer = $(e.currentTarget);
    const $video = $videoContainer.find('iframe');
    const src = $video.attr('src');
    let autoplaySrc = src;

    if (src.indexOf('?') > -1) {
      autoplaySrc += '&';
    }

    autoplaySrc += 'autoplay=1';
    $video.attr('src', autoplaySrc).trigger('load');
    $videoContainer.find('.RteVideo__cover--active').removeClass('RteVideo__cover--active');

  });
}
